import userPrepare from './userPrepare'
import shippingRate from './shippingRate'
import tpTaobaoTradeItem from './tpTaobaoTradeItem'
import tpCatalogQa from './tpCatalogQa'
import ordersubtno from './ordersubtno'
import parcelPtyt from './parcelPtyt'
import ordersubtnoDisp from './ordersubtnoDisp'
const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    userPrepare,
    shippingRate,
    tpTaobaoTradeItem,
    tpCatalogQa,
    ordersubtno,
    parcelPtyt,
    ordersubtnoDisp,
  }
}
